import { FC } from 'react';

import { DateTime } from 'luxon';

const STAMP_COLUMN_PX = 380;
const STAMP_ROW_PX = 100;
const MAX_STAMPS = 1200;

export const formatOpenedAt = (iso: string): string => {
  const parsed = DateTime.fromISO(iso);
  return parsed.isValid ? parsed.toFormat('M/d/yyyy h:mm a ZZZZ') : iso;
};

export const stampCountFor = (screenWidth: number, screenHeight: number): number =>
  Math.min(
    MAX_STAMPS,
    Math.max(
      1,
      Math.ceil((screenWidth * 2) / STAMP_COLUMN_PX) * Math.ceil((screenHeight * 2) / STAMP_ROW_PX),
    ),
  );

export const currentStampCount = (): number => {
  const { width, height } = window.screen ?? { width: 1920, height: 1080 };
  return stampCountFor(width || 1920, height || 1080);
};

export const StampOverlay: FC<{ text: string; stampCount: number }> = ({ text, stampCount }) => (
  <div
    aria-hidden="true"
    data-testid="irm-stamp-overlay"
    className="pointer-events-none absolute inset-0 select-none overflow-hidden"
  >
    <div
      className="absolute flex flex-wrap content-start gap-x-16 gap-y-24 text-sm"
      style={{ inset: '-50%', transform: 'rotate(-24deg)', color: 'rgba(128, 128, 128, 0.25)' }}
    >
      {Array.from({ length: stampCount }, (_unused, index) => (
        <span key={index} className="whitespace-nowrap">
          {text}
        </span>
      ))}
    </div>
  </div>
);
